import React from 'react';

type Props = {} & React.SVGProps<SVGSVGElement>;

const SvgSmileyOkay = (props: Props): JSX.Element => {
  return (
    // @ts-ignore
    <svg
      viewBox="0 0 35 35" {...props}
    >
      <path
        d="M17.5.247C7.972.247.247 7.972.247 17.5S7.971 34.753 17.5 34.753c9.528 0 17.253-7.724 17.253-17.253C34.753 7.972 27.028.247 17.5.247zm5.128 9.617a3.219 3.219 0 110 6.437 3.219 3.219 0 010-6.437zm-10.256-.283a3.219 3.219 0 110 6.437 3.219 3.219 0 010-6.437zm14.504 15.328L9.51 26.59a1.177 1.177 0 11-.227-2.341l17.366-1.681a1.172 1.172 0 011.284 1.058 1.174 1.174 0 01-1.057 1.283z"
      />
    </svg>
  );
};

export default SvgSmileyOkay;
